import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from "@angular/http";

import { Fmt } from '../../fmt.service';

@Injectable()
export class LoginService {
    constructor(
        public _fmt: Fmt,
        public _http: Http
    ) {}

    Login(credentials: any): Observable<Response> {
        return this._http.post('/api/v1/token-auth', credentials)
    }
}